import script from "./CalendarNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarNavigation.vue?vue&type=script&setup=true&lang=js"

import "./CalendarNavigation.vue?vue&type=style&index=0&id=38030558&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38030558"]])

export default __exports__